import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Eye, EyeSlash } from '@phosphor-icons/react';
import axios from 'axios';

export default function WachtwoordResetPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(token ? '' : 'Geen reset-token in de URL. Vraag een nieuwe link aan.');

  const submit = async (e) => {
    e.preventDefault();
    if (!pw || pw.length < 8) {
      setError('Wachtwoord moet minimum 8 tekens hebben');
      return;
    }
    if (pw !== pw2) {
      setError('De twee wachtwoorden komen niet overeen');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const apiBase = process.env.REACT_APP_BACKEND_URL;
      await axios.post(`${apiBase}/api/auth/reset-password`, { token, password: pw });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (e) {
      setError(e.response?.data?.detail || 'Er ging iets mis');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md" data-testid="wachtwoord-reset-page">
        <div className="bg-white shadow-sm border border-gray-100">
          <div className="px-7 py-6 border-b border-gray-100">
            <h1 className="text-2xl font-bold text-gray-900">Nieuw wachtwoord instellen</h1>
            <p className="text-sm text-gray-600 mt-1">Kies een sterk wachtwoord van minimum 8 tekens.</p>
          </div>

          <div className="px-7 py-6">
            {done ? (
              <div className="text-center space-y-4" data-testid="wachtwoord-reset-success">
                <div className="text-5xl">✅</div>
                <p className="text-sm text-gray-700 font-medium">Je wachtwoord is opnieuw ingesteld.</p>
                <p className="text-xs text-gray-500">Je wordt automatisch doorgestuurd naar de login-pagina...</p>
                <Link to="/login" className="inline-block btn btn-primary mt-2" data-testid="wachtwoord-reset-naar-login">Direct inloggen</Link>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="form-label">Nieuw wachtwoord</label>
                  <div className="relative">
                    <input
                      type={show ? 'text' : 'password'}
                      className="field-input pr-10"
                      value={pw}
                      onChange={(e) => setPw(e.target.value)}
                      placeholder="••••••••"
                      autoComplete="new-password"
                      autoFocus
                      data-testid="wachtwoord-reset-pw1"
                    />
                    <button
                      type="button"
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      onClick={() => setShow(!show)}
                    >
                      {show ? <EyeSlash size={16} /> : <Eye size={16} />}
                    </button>
                  </div>
                </div>
                <div>
                  <label className="form-label">Bevestig wachtwoord</label>
                  <input
                    type={show ? 'text' : 'password'}
                    className="field-input"
                    value={pw2}
                    onChange={(e) => setPw2(e.target.value)}
                    placeholder="••••••••"
                    autoComplete="new-password"
                    data-testid="wachtwoord-reset-pw2"
                  />
                </div>
                {error && (
                  <div className="p-3 bg-red-50 border border-red-200 text-red-600 text-sm" data-testid="wachtwoord-reset-error">
                    {error}
                  </div>
                )}
                <button
                  type="submit"
                  disabled={loading || !token}
                  className="btn btn-primary w-full justify-center"
                  data-testid="wachtwoord-reset-submit"
                >
                  {loading ? 'Bezig...' : 'Wachtwoord opslaan'}
                </button>
                <div className="text-center pt-2">
                  <Link to="/login" className="text-xs text-gray-500 hover:text-[#002FA7]">← Terug naar inloggen</Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
